import store from "@/state/store";

export default [
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/dashboard"),
  },
  {
    path: "/login",
    name: "login",
    props: true,
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {

          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    props: true,
    component: () => import("../views/account/logout.vue"),
    meta: {
      title: "Logout",
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/riskurl",
    name: "URL Scanner",
    meta: { title: "URL Scanner", authRequired: true },
    component: () => import("../views/riskurl/riskurl"),
  },
  {
    path: "/monitors/blacklists",
    name: "blacklist",
    meta: {
      title: "blacklist",
      authRequired: true,
    },
    component: () => import("../views/monitors/blacklists/list"),
  },
  {
    path: "/monitors/certificates",
    name: "certificates",
    meta: { title: "certificates", authRequired: true },
    component: () => import("../views/monitors/certificates/list"),
  },
  {
    path: "/account/settings",
    name: "settings",
    meta: { title: "certificates", authRequired: true },
    component: () => import("../views/account/settings"),
  },
  {
    path: "/account/invoices",
    name: "Invoices",
    meta: { title: "API Key", authRequired: true },
    component: () => import("../views/account/invoices"),
  }
];
